<script lang="ts" setup>
import { BuyerNotifyMutation } from '@gql/BuyerNotifyMutation'

const t2 = useT2({
  'No Price': 'Nėra kainos',
  'Price must be below': 'Kaina turi būti mažesnė nei',
  'Back in Stock': 'Prekė vėl prekyboje',
  'Price Below': 'Kaina žemiau',
  Subscribe: 'Prenumeruoti',
  Subscribed: 'Prenumeruota',
  'Lower Price': 'Sumažėjusi kaina',
  'Cancel Subscription': 'Atšaukti prenumeratą',
  'Notify when below': 'Pranešti, kai bus žemiau',
  'You will receive an email at': 'Gausite el. laišką adresu',
  'when the price drops below': 'kai kaina nukris žemiau',
})

const props = defineProps<{
  view: 'product' | 'user'
  notify: ReturnType<typeof useNotify>
  doc: gen.BuyerNotifyDocFragment | None
  inStock: boolean
  pad?: boolean
  productPrice: number
  productId: string
}>()

const auth = useAuth()
const timer = useTimeout()
const open = shallowRef(false)
const notifyDoc = useValueCache(() => props.doc)
const formPrice2 = useValueCache(() => notifyDoc.value?.onPriceDrop?.toString() || (Math.round(props.productPrice * 10 * 0.9) / 10).toString())
const formPriceNumb = computed(() => helpers.toNumber(formPrice2.value))
const formPriceUi = computed(() => helpers.priceFormat(formPriceNumb.value))

function mutat123e(vars: gen.BuyerNotifyMutationVariables) {
  return useGqlMutate<gen.BuyerNotifyMutation, gen.BuyerNotifyMutationVariables>(BuyerNotifyMutation, {
    clientId: 'post',
    vars,
  })
}

function mutate(input: gen.InputBuyerNotify) {
  return props.notify.watch(mutat123e({ input })).then((i) => {
    if (i?.data?.buyerNotify?.responseInfo.success) timer.set(() => (open.value = false), 100)
    return i?.data?.buyerNotify || null
  })
}

const stock = computed((): boolean => !!notifyDoc?.value?.isActive && notifyDoc?.value?.type === 'Stock')

function cancelSub() {
  return mutate({ removeProductId: { _id: props.productId } })
}
function subscribeToAvaialbe() {
  if (stock.value) return cancelSub()
  return mutate({ set: { productId: props.productId, onInStock: true, type: 'Stock' } })
}

const elemInput = useTemplateRef('elemInput')
function formSave() {
  const onPriceDrop = helpers.toNumber(getFormValueOne(elemInput))
  if (!onPriceDrop || onPriceDrop <= 0) return props.notify.error(t2('No Price'))
  if (onPriceDrop >= props.productPrice) return props.notify.error(t2('Price must be below'))
  return mutate({ set: { productId: props.productId, onPriceDrop, onInStock: false, type: 'Price' } })
}

const priceMsg = computed(() => {
  const p = notifyDoc.value?.onPriceDrop
  return p ? ts(t2('Notify when below'), helpers.priceFormat(p)) : undefined
})

const ui = computed((): { stock: boolean; price: boolean } => {
  const { view, inStock } = props
  const doc = notifyDoc.value
  if (view === 'product') {
    return {
      stock: !inStock || (!!doc?.isActive && doc?.type === 'Stock'),
      price: inStock || (!!doc?.isActive && doc?.type === 'Price'),
    }
  }
  return {
    stock: doc?.type === 'Stock',
    price: doc?.type === 'Price',
  }
})
</script>

<template>
  <div v-if="ui.stock" class="_mb06" :class="[$style[view], pad && '_ml06 _mr06']">
    <BoardModalBtn
      count="off"
      :label="t2('Back in Stock')"
      :active="stock"
      :msg="inStock ? 'In stock' : stock ? 'Remove' : 'Subscribe'"
      :images="[]"
      :submit="() => subscribeToAvaialbe()"
      :sup="stock ? t2('Subscribed') : undefined"
    >
      <template #icon><IconReturns class="_svg24" /></template>
    </BoardModalBtn>
  </div>

  <div v-if="ui.price" :class="[$style.box, $style[view], pad && '_ml06 _mr06']">
    <BoardModalBtn
      count="off"
      :label="t2('Lower Price')"
      :active="!open && !!notifyDoc?.onPriceDrop"
      :images="[]"
      :msg="open ? 'Close' : notifyDoc?.onPriceDrop ? 'Update' : 'Add'"
      :btn-color="open ? 'grey' : undefined"
      :submit="() => (open = !open)"
      :sup="priceMsg"
    >
      <template #icon>
        <IconDiscount class="_svg24" />
      </template>
    </BoardModalBtn>

    <UiGrow :open>
      <div :class="$style.form">
        <InputNumber ref="elemInput" :label="t2('Price Below')" :max="productPrice" :model-value="formPriceNumb" type="price" />

        <div class="_row _gap1 _pt1 _pb2">
          <ButtonAction color :submit="() => formSave()" :txt="notifyDoc?.onPriceDrop ? t2('Update') : t2('Subscribe')" />
          <ButtonAction v-if="notifyDoc?.onPriceDrop" :submit="() => cancelSub()" :txt="t2('Cancel Subscription')" />
        </div>

        <div class="_italic">
          {{ t2('You will receive an email at') }}
          <em>{{ auth.email }}</em>
          {{ t2('when the price drops below') }}
          <span class="_mono _mark">{{ formPriceUi }}.</span>
        </div>
      </div>
    </UiGrow>
  </div>
</template>

<style module>
.box,
.box1 {
  composes: global(_br14);
  composes: global(_bg0);
}

.form {
  composes: global(_mt1);
  composes: global(_pt1);
  composes: global(_pl04);
  composes: global(_pr04);
  composes: global(_bw100);
  composes: global(_b5);
}
</style>
